/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

export type OnboardingDriverLicenseDtoLicenseType = typeof OnboardingDriverLicenseDtoLicenseType[keyof typeof OnboardingDriverLicenseDtoLicenseType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OnboardingDriverLicenseDtoLicenseType = {
  NONE: 'NONE',
  EUROPEAN: 'EUROPEAN',
  BELGIAN: 'BELGIAN',
  OTHER: 'OTHER',
} as const;
